// Runtime configuration - loaded from config.json deployed by CDK
let config = null;

export const loadConfig = async () => {
  if (config) {
    return config;
  }

  try {
    const response = await fetch('/config.json');
    if (!response.ok) {
      throw new Error(`Failed to load config: ${response.status}`);
    }
    config = await response.json();
    console.log('Configuration loaded successfully');
    return config;
  } catch (error) {
    console.error('Error loading configuration:', error);
    // Fallback to environment variables for local development
    config = {
      apiUrl: process.env.REACT_APP_API_URL || '',
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
    };
    return config;
  }
};

export const getConfig = () => {
  if (!config) {
    throw new Error('Configuration not loaded. Call loadConfig() first.');
  }
  return config;
};
